import React from 'react';
import PropTypes from 'prop-types';
import { useDebugState } from 'Context/DebugContext';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import DevResourceViewerLine from 'Components/ComponentLibrary/Organisms/DevResourceViewer/DevResourceViewerLine';
import Text from 'Components/ComponentLibrary/Atoms/Text';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { getBorder, getBorderRadius } from 'Components/utils';
import DevResourceViewerSection from './DevResourceViewerSection';
import DevRelationshipButtons from './DevRelationshipButtons';

const useStyles = buildUseStyles('', ((theme) => ({
  root: {
    margin: theme.spacing(1),
    padding: theme.spacing(2),
    gap: `${theme.spacing(2)}px`,
    ...getBorder(theme, { all: true }),
    ...getBorderRadius(theme.radius.md, { all: true }),
  },
})));

const DevResourceViewer = ({ resource, onRelationshipClick }) => {
  const { showDevElements } = useDebugState();
  const classes = useStyles();

  if (!showDevElements) {
    return null;
  }

  return (
    <Box
      className={classes.root}
      display={'flex'}
      flexDirection={'column'}
      alignItems={'flexStart'}
    >
      <Text
        value={'Resource Viewer'}
        color={'black'}
        variant={'h5'}
        weight={'bold'}
      />
      <DevResourceViewerSection value={'Summary'}>
        <DevResourceViewerLine label={'id'} value={resource.id()} />
        <DevResourceViewerLine label={'type'} value={resource.type()} />
      </DevResourceViewerSection>
      <DevResourceViewerSection value={'Query Params'}>
        {[...new URL(resource.link('self').url()).searchParams.entries()].map(([k, v], i) => {
          return (
            <DevResourceViewerLine
              key={`${i}.${k}`} // eslint-disable-line react/no-array-index-key
              label={k}
              value={v}
            />
          );
        })}
      </DevResourceViewerSection>
      <DevResourceViewerSection value={'Relationships'}>
        <DevRelationshipButtons
          onClick={onRelationshipClick}
          resource={resource}
        />
      </DevResourceViewerSection>
    </Box>
  );
};

DevResourceViewer.propTypes = {
  resource: PropTypes.object.isRequired,
  onRelationshipClick: PropTypes.func.isRequired,
};

export default DevResourceViewer;
